import store from '../store'

const setLoading = function (v) {
    store.dispatch('common/setIsLoading', v)
}
export default setLoading



// WEBPACK FOOTER //
// ./src/util/global.js